// import React, { useEffect } from "react";
// import { Link } from "react-router-dom";

// const Header = () => {
//   useEffect(() => {
//     let lastScrollTop = 0;

//     const handleScroll = () => {
//       const header = document.querySelector(".headercontainer");
//       const st = window.pageYOffset || document.documentElement.scrollTop;

//       if (st > lastScrollTop) {
//         if (window.pageYOffset > 0) {
//           header.classList.add("sticky");
//         }
//         if (window.pageYOffset > 500) {
//           header.classList.add("sticky-hide");
//         }
//       } else {
//         if (window.pageYOffset === 0) {
//           header.classList.remove("sticky");
//         } else {
//           header.classList.remove("sticky-hide");
//         }
//       }

//       lastScrollTop = st <= 0 ? 0 : st;
//     };

//     window.addEventListener("scroll", handleScroll);

//     // Cleanup on unmount
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   return (
//     <header className="headercontainer">
//       <div className="container">
//         <div className="headtoprow">
//           <div className="logocontainer">
//             <Link to="/">
//               <img
//                 src={process.env.PUBLIC_URL + "/images/logo.png"}
//                 alt="Logo"
//               />
//             </Link>
//           </div>

//           <div className="navigation">
//             <div className="navigationbox">
//               <div className="navuser">
//                 <a href="#" className="userimg">
//                   <img
//                     src={process.env.PUBLIC_URL + "/images/user-1.jpg"}
//                     alt="User"
//                   />
//                 </a>
//                 <div className="w-100">
//                   <h3>
//                     <a href="#">James Anderson</a>
//                   </h3>
//                 </div>
//               </div>

//               <ul className="sf-menu">
//                 <li className="active">
//                   <Link to="/">Home</Link>
//                 </li>
//                 <li>
//                   <Link to="/about">About Us</Link>
//                 </li>
//                 <li>
//                   <Link to="/contact">Contact</Link>
//                 </li>
//               </ul>

//               <div className="userbts">
//                 <div className="language d-none d-lg-block">
//                   <a href="#">Language</a>
//                   <div className="languagedrop">
//                     <ul>
//                       <li><a href="#">English</a></li>
//                       <li><a href="#">Hindi</a></li>
//                       <li><a href="#">Japanese</a></li>
//                       <li><a href="#">French</a></li>
//                     </ul>
//                   </div>
//                 </div>
//                 <button className="default-btn" type="button">
//                   List Your Property
//                 </button>
//                 {/* <button className="theme-btn" type="button">
//                   Sign in / Sign up
//                 </button> */}

//                    <Link
//           to="/register"
//           className="theme-btn"
//         >
//           Sign Up
//         </Link>
//               </div>
//             </div>

//             <div className="language d-lg-none">
//               <a href="#">Language</a>
//               <div className="languagedrop">
//                 <ul>
//                   <li><a href="#">English</a></li>
//                   <li><a href="#">Hindi</a></li>
//                   <li><a href="#">Japanese</a></li>
//                   <li><a href="#">French</a></li>
//                 </ul>
//               </div>
//             </div>

//             <a className="NavBar" href="#">
//               <i className="icon icon-segment"></i>
//             </a>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";

// const Header = () => {
//   const [user, setUser] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     // Check if user is logged in
//     const storedUser = localStorage.getItem("user");
//     if (storedUser) {
//       setUser(JSON.parse(storedUser));
//     }

//     let lastScrollTop = 0;

//     const handleScroll = () => {
//       const header = document.querySelector(".headercontainer");
//       const st = window.pageYOffset || document.documentElement.scrollTop;

//       if (st > lastScrollTop) {
//         if (window.pageYOffset > 0) {
//           header.classList.add("sticky");
//         }
//         if (window.pageYOffset > 500) {
//           header.classList.add("sticky-hide");
//         }
//       } else {
//         if (window.pageYOffset === 0) {
//           header.classList.remove("sticky");
//         } else {
//           header.classList.remove("sticky-hide");
//         }
//       }

//       lastScrollTop = st <= 0 ? 0 : st;
//     };

//     window.addEventListener("scroll", handleScroll);
// console.log('user',user)
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   const handleLogout = () => {
//     localStorage.clear();
//     setUser(null);
//     navigate("/"); // redirect to home after logout
//   };

//   return (
//     <header className="headercontainer">
//       <div className="container">
//         <div className="headtoprow">
//           <div className="logocontainer">
//             <Link to="/">
//               <img
//                 src={process.env.PUBLIC_URL + "/images/logo.png"}
//                 alt="Logo"
//               />
//             </Link>
//           </div>

//           <div className="navigation">
//             <div className="navigationbox">
//               <div className="navuser">
//                 <a href="#" className="userimg">
//                   <img
//                     src={process.env.PUBLIC_URL + "/images/user-1.jpg"}
//                     alt="User"
//                   />
//                 </a>
//                 <div className="w-100">
//                   <h3>
//                     <a href="#">{user ? user.firstName + " " + user.lastName : "James Anderson"}</a>
//                   </h3>
//                 </div>
//               </div>

//               <ul className="sf-menu">
//                 <li className="active">
//                   <Link to="/">Home</Link>
//                 </li>
//                 <li>
//                   <Link to="/about">About Us</Link>
//                 </li>
//                 <li>
//                   <Link to="/contact">Contact</Link>
//                 </li>
//               </ul>

//               <div className="userbts">
//                 <div className="language d-none d-lg-block">
//                   <a href="#">Language</a>
//                   <div className="languagedrop">
//                     <ul>
//                       <li><a href="#">English</a></li>
//                       <li><a href="#">Hindi</a></li>
//                       <li><a href="#">Japanese</a></li>
//                       <li><a href="#">French</a></li>
//                     </ul>
//                   </div>
//                 </div>
//                 <button className="default-btn" type="button">
//                   List Your Property
//                 </button>

//                 {!user ? (
//                   <Link to="/register" className="theme-btn">
//                     Sign Up
//                   </Link>
//                 ) : (
//                   <>
//                     <Link to="/profile" className="userbrx">
//                        <img src={user.profile_image} alt={user.firstname} />
//                        <div className="userbrxct">
//                         <p><span>Welcome</span><strong>{user?.firstname}</strong></p>
//                        </div>
//                     </Link>
//                     <button className="theme-btn logoutbtn" onClick={handleLogout}>
//                       <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M21 12L13 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                         <path d="M18 15L20.913 12.087V12.087C20.961 12.039 20.961 11.961 20.913 11.913V11.913L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                         <path d="M16 5V4.5V4.5C16 3.67157 15.3284 3 14.5 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H14.5C15.3284 21 16 20.3284 16 19.5V19.5V19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                       </svg>
//                       <span className="d-lg-none">Logout</span>
//                     </button>
//                   </>
//                 )}
//               </div>
//             </div>

//             <div className="language d-lg-none">
//               <a href="#">Language</a>
//               <div className="languagedrop">
//                 <ul>
//                   <li><a href="#">English</a></li>
//                   <li><a href="#">Hindi</a></li>
//                   <li><a href="#">Japanese</a></li>
//                   <li><a href="#">French</a></li>
//                 </ul>
//               </div>
//             </div>

//             <a className="NavBar" href="#">
//               <i className="icon icon-segment"></i>
//             </a>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";

// const Header = () => {
//   const [user, setUser] = useState(null);
//   const [imageError, setImageError] = useState(false); // track if image failed
//   const navigate = useNavigate();

//   useEffect(() => {
//     const storedUser = localStorage.getItem("user");
//     if (storedUser) {
//       setUser(JSON.parse(storedUser));
//     }

//     let lastScrollTop = 0;

//     const handleScroll = () => {
//       const header = document.querySelector(".headercontainer");
//       const st = window.pageYOffset || document.documentElement.scrollTop;

//       if (st > lastScrollTop) {
//         if (window.pageYOffset > 0) {
//           header.classList.add("sticky");
//         }
//         if (window.pageYOffset > 500) {
//           header.classList.add("sticky-hide");
//         }
//       } else {
//         if (window.pageYOffset === 0) {
//           header.classList.remove("sticky");
//         } else {
//           header.classList.remove("sticky-hide");
//         }
//       }

//       lastScrollTop = st <= 0 ? 0 : st;
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const handleLogout = () => {
//     localStorage.clear();
//     setUser(null);
//     navigate("/"); // redirect to home after logout
//   };

//   const getInitial = (name) => (name ? name.charAt(0).toUpperCase() : "?");

//   return (
//     <header className="headercontainer">
//       <div className="container">
//         <div className="headtoprow">
//           <div className="logocontainer">
//             <Link to="/">
//               <img
//                 src={process.env.PUBLIC_URL + "/images/logo.png"}
//                 alt="Logo"
//               />
//             </Link>
//           </div>

//           <div className="navigation">
//             <div className="navigationbox">
//               <div className="navuser">
//                 {user ? (
//                   <Link to="/profile" className="userimg">
//                     {user.profile_image && !imageError ? (
//                       <img
//                         src={user.profile_image}
//                         alt={user.firstName}
//                         onError={() => setImageError(true)}
//                       />
//                     ) : (
//                       <div className="user-icon">
//                         {getInitial(user.firstName)}
//                       </div>
//                     )}
//                   </Link>
//                 ) : (
//                   <a href="#" className="userimg">
//                     <img
//                       src={process.env.PUBLIC_URL + "/images/user-1.jpg"}
//                       alt="User"
//                     />
//                   </a>
//                 )}

//                 <div className="w-100">
//                   <h3>
//                     <a href="#">
//                       {user
//                         ? `${user.firstName} ${user.lastName}`
//                         : "James Anderson"}
//                     </a>
//                   </h3>
//                 </div>
//               </div>

//               <ul className="sf-menu">
//                 <li className="active">
//                   <Link to="/">Home</Link>
//                 </li>
//                 <li>
//                   <Link to="/about">About Us</Link>
//                 </li>
//                 <li>
//                   <Link to="/contact">Contact</Link>
//                 </li>
//               </ul>

//               <div className="userbts">
//                 <div className="language d-none d-lg-block">
//                   <a href="#">Language</a>
//                   <div className="languagedrop">
//                     <ul>
//                       <li><a href="#">English</a></li>
//                       <li><a href="#">Hindi</a></li>
//                       <li><a href="#">Japanese</a></li>
//                       <li><a href="#">French</a></li>
//                     </ul>
//                   </div>
//                 </div>
//                 <button className="default-btn" type="button">
//                   List Your Property
//                 </button>

//                 {!user ? (
//                   <Link to="/register" className="theme-btn">
//                     Sign Up
//                   </Link>
//                 ) : (
//                   <>
//                     <Link to="/profile" className="userbrx">
//                       {user.profile_image && !imageError ? (
//                         <img
//                           src={user.profile_image}
//                           alt={user.firstName}
//                           onError={() => setImageError(true)}
//                         />
//                       ) : (
//                         <div className="user-icon-small">
//                           {getInitial(user.firstName)}
//                         </div>
//                       )}
//                       <div className="userbrxct">
//                         <p>
//                           <span>Welcome</span>
//                           <strong>{user.firstName}</strong>
//                         </p>
//                       </div>
//                     </Link>
//                     <button
//                       className="theme-btn logoutbtn"
//                       onClick={handleLogout}
//                     >
//                       <svg
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M21 12L13 12"
//                           stroke="currentColor"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                         <path
//                           d="M18 15L20.913 12.087V12.087C20.961 12.039 20.961 11.961 20.913 11.913V11.913L18 9"
//                           stroke="currentColor"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                         <path
//                           d="M16 5V4.5V4.5C16 3.67157 15.3284 3 14.5 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H14.5C15.3284 21 16 20.3284 16 19.5V19.5V19"
//                           stroke="currentColor"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>
//                       <span className="d-lg-none">Logout</span>
//                     </button>
//                   </>
//                 )}
//               </div>
//             </div>

//             <div className="language d-lg-none">
//               <a href="#">Language</a>
//               <div className="languagedrop">
//                 <ul>
//                   <li><a href="#">English</a></li>
//                   <li><a href="#">Hindi</a></li>
//                   <li><a href="#">Japanese</a></li>
//                   <li><a href="#">French</a></li>
//                 </ul>
//               </div>
//             </div>

//             <a className="NavBar" href="#">
//               <i className="icon icon-segment"></i>
//             </a>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { changeLanguage } from "../utils/googleTranslate";

const Header = () => {
  const [user, setUser] = useState(null);
  const [imageError, setImageError] = useState(false);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const languages = [
    { code: "en", label: "English" },
    { code: "hi", label: "Hindi" },
    { code: "bn", label: "Bengali" },
  ];

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("layout-expanded2");
    } else {
      document.body.classList.remove("layout-expanded2");
    }

    return () => {
      document.body.classList.remove("layout-expanded2");
    };
  }, [menuOpen]);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    let lastScrollTop = 0;

    const handleScroll = () => {
      const header = document.querySelector(".headercontainer");
      const st = window.pageYOffset || document.documentElement.scrollTop;

      if (st > lastScrollTop) {
        if (window.pageYOffset > 0) header.classList.add("sticky");
        if (window.pageYOffset > 500) header.classList.add("sticky-hide");
      } else {
        if (window.pageYOffset === 0) {
          header.classList.remove("sticky");
        } else {
          header.classList.remove("sticky-hide");
        }
      }

      lastScrollTop = st <= 0 ? 0 : st;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setUser(null);
    navigate("/");
  };

  //. Normalize fields for both normal & Google login
  const getFirstName = () =>
    user?.firstName ||
    user?.firstname ||
    user?.given_name ||
    "";

  const getLastName = () =>
    user?.lastName ||
    user?.lastname ||
    user?.family_name ||
    "";

  const getFullName = () => `${getFirstName()} ${getLastName()}`.trim();

  const getInitial = () => {
    const fn = getFirstName();
    return fn ? fn.charAt(0).toUpperCase() : "?";
  };

  //. Handle List Your Property Click
  const handleListProperty = () => {
    if (!user) {
      navigate("/login");
    } else if (user.role === "owner") {
      // navigate("/upload-property");
      navigate("/upload-property", {
        state: { addnewproperties: true }, // important flag for BasicInfo logic
      });
    } else {
      toast.warn("Only property owners can list a property.");
    }
  };

useEffect(() => {
  const observer = new MutationObserver(() => {
    document.querySelectorAll("font").forEach((el) => {
      el.removeAttribute("style");
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  return () => observer.disconnect();
}, []);
  // 

  return (
    <header className="headercontainer">


      <div className="container">
        <div className="headtoprow">
          <div className="logocontainer">
            <Link to="/">
              <img
                src={process.env.PUBLIC_URL + "/images/logo.png"}
                alt="Logo"
              />
            </Link>
          </div>

          <div className="navigation">
            {menuOpen && (
              <>
                <div
                  className="layoutovarlay"
                  onClick={() => setMenuOpen(false)}
                ></div>

                <div
                  className="layoutovarlay2"
                  onClick={(e) => {
                    e.preventDefault();
                    setMenuOpen(false);
                  }}
                ></div>
              </>
            )}

            <div className="navigationbox">
              <div className="navuser">
                {user ? (
                  <Link to="/profile" className="userimg">
                    {user.profile_image && !imageError ? (
                      <img
                        src={user.profile_image}
                        alt={getFirstName()}
                        onError={() => setImageError(true)}
                      />
                    ) : (
                      <div className="user-icon">{getInitial()}</div>
                    )}
                  </Link>
                ) : (
                  <a href="#" className="sidebar-logo">
                    <img
                      style={{ width: "100px", height: "30px" }}
                      src={process.env.PUBLIC_URL + "/images/logo.png"}
                      alt="GuestLinkUp"
                    />
                  </a>
                )}

                <div className="w-100">
                  <h3>
                    <a href="#">
                      {user ? getFullName() : ""}
                    </a>
                  </h3>
                </div>
              </div>

              <ul className="sf-menu">
                <li className={location.pathname === "/" ? "active" : ""}>
                  <Link to="/">Home</Link>
                </li>

                <li className={location.pathname === "/about" ? "active" : ""}>
                  <Link to="/about">About Us</Link>
                </li>

                <li className={location.pathname === "/contact" ? "active" : ""}>
                  <Link to="/contact">Contact</Link>
                </li>

                <li className={location.pathname.startsWith("/help-center") ? "active" : ""}>
                  <Link to="/help-center">Help Center</Link>
                </li>
              </ul>


              <div className="userbts">
                {!menuOpen && (
                  <div className="language ">
                    <a style={{ cursor: "pointer" }} className="">Language</a>
                    <div className="languagedrop notranslate">
                      <ul className="notranslate">
                        {languages.map((lang) => (
                          <li key={lang.code} className="notranslate">
                            <a
                              style={{ cursor: "pointer" }}
                              className="notranslate"
                              onClick={() => changeLanguage(lang.code)}
                            >
                              {lang.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                <button
                  className="default-btn"
                  type="button"
                  onClick={handleListProperty}
                >
                  List Your Property
                </button>

                {!user ? (
                  <Link to="/login" className="theme-btn">
                    Sign In
                  </Link>
                ) : (
                  <>
                    <Link to="/profile" className="userbrx">
                      {user.profile_image && !imageError ? (
                        <img
                          src={user.profile_image}
                          alt={getFirstName()}
                          onError={() => setImageError(true)}
                        />
                      ) : (
                        <div className="user-icon-small">{getInitial()}</div>
                      )}
                      <div className="userbrxct">
                        <p>
                          <span>Welcome</span>
                          <strong>{getFirstName() || "Guest User"}</strong>
                        </p>
                      </div>
                    </Link>
                    <button
                      className="theme-btn logoutbtn"
                      onClick={handleLogout}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21 12L13 12"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M18 15L20.913 12.087V12.087C20.961 12.039 20.961 11.961 20.913 11.913V11.913L18 9"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M16 5V4.5V4.5C16 3.67157 15.3284 3 14.5 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H14.5C15.3284 21 16 20.3284 16 19.5V19.5V19"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="d-lg-none">Logout</span>
                    </button>
                  </>
                )}
              </div>
            </div>

            <div className="language d-lg-none">
              <a href="#" className="">Language</a>
              <div className="languagedrop notranslate">
                <ul className="notranslate">
                  {languages.map((lang) => (
                    <li key={lang.code} className="notranslate">
                      <a
                        href="#"
                        className="notranslate"
                        onClick={() => changeLanguage(lang.code)}
                      >
                        {lang.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <a
              className="NavBar"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setMenuOpen(true);
              }}
            >
              <i className="icon icon-segment"></i>
            </a>

          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
